module.exports = __webpack_public_path__ + "img/motorbikeOverview4Outline.9bb5c876.svg";